<template>
  <div>
  <v-dialog
    :model-value="modelValue"
    max-width="1250"
    height="80vh"
    persistent
    @update:model-value="val => emit('update:modelValue', !!val)"
  >
    <v-card class="purchase-dialog">
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="d-flex justify-space-between align-center" style="flex: 1;">
          <div>
            <span>转采购项</span>
          </div>
          <div style="margin-top: 4px; text-align: right;">
            <div v-if="projectName" style="font-size: 18px;">{{ projectName }}</div>
            <div v-if="contractCode" style="font-size: 14px; color: #a5a5a5; line-height: 1;">{{ contractCode }}</div>
          </div>
        </div>
        <v-btn icon="mdi-close" variant="text" @click="handleClose" />
      </v-card-title>
      <v-card-text>
        <div class="material-purchase-list">
          <div class="material-purchase-header">
            <div class="item-content" style="width: 44px;"></div>
            <div class="item-content" style="width: 150px; text-align: left;">采购项</div>
            <div class="item-content" style="width: 10%; text-align: center;">关联产品</div>
            <!-- <div class="item-content" style="width: 8%;">数量</div>
            <div class="item-content" style="width: 100px;">单位</div>
            <div class="item-content" style="width: 8%;">单价</div>
            <div class="item-content" style="width: 11%;">金额</div>
            <div class="item-content" style="flex: 1;">备注</div>
            <div class="item-content" style="width: 180px;">计划交货</div> -->
          </div>
          <div class="material-purchase-body">
            <div
              v-for="(row, index) in localRows"
              :key="row._selectedKey || row.id || index"
              class="material-purchase-item"
            >
              <div class="item-content" style="width: 44px;">{{ index + 1 }}</div>
              <div class="item-content" style="width: 150px; text-align: left;">
                <div v-if="row.purchaseItemType !== 1"
                  class="purchase-item-editable"
                  @click="openMaterialFieldDialog(row)"
                >
                  <img
                    :src="editIcon"
                    alt="编辑"
                    class="purchase-item-edit-icon"
                  >
                  <div class="material-name" style="text-align: left;" v-if="row.partName">{{ row.partName }}</div>
                  <div class="material-name" style="text-align: left;" v-if="row.materialName">{{ row.materialName }}</div>
                  <div style="text-align: left;" v-if="row.specDesc || row.materialSpec">{{ row.specDesc || row.materialSpec }}</div>
                  <div class="material-code" style="text-align: left;" v-if="row.materialCode">{{ row.materialCode }}</div>
                  <div class="material-code" style="text-align: left;">{{ row.batch }}</div>
                </div>
                <div v-else>
                  <div class="material-name" style="text-align: left;" v-if="row.partName">{{ row.partName }}</div>
                  <div class="material-name" style="text-align: left;" v-if="row.materialName">{{ row.materialName }}</div>
                  <div style="text-align: left;" v-if="row.specDesc || row.materialSpec">{{ row.specDesc || row.materialSpec }}</div>
                  <div class="material-code" style="text-align: left;" v-if="row.materialCode">{{ row.materialCode }}</div>
                  <div class="material-code" style="text-align: left;">{{ row.batch }}</div>
                </div>
              </div>
              <div class="item-content" style="width: 10%;">
                <v-tooltip
                  v-if="row.productCodes && row.productCodes.length > 0"
                  location="top"
                  max-width="360"
                >
                  <template #activator="{ props: tipProps }">
                    <span v-bind="tipProps" class="purchase-associated-products-tip-wrap">
                      <img
                        :src="inputTipImg"
                        alt="关联产品"
                        class="purchase-associated-products-tip-img"
                      >
                      <span
                        v-if="row.productCodes?.length > 0"
                        class="purchase-associated-products-count"
                      >
                        {{ row.productCodes?.length }}件
                      </span>
                    </span>
                  </template>
                  <div class="purchase-associated-products-tooltip">
                    <div
                      v-for="(productCode, pcIdx) in row.productCodes"
                      :key="pcIdx"
                    >
                      {{ productCode }}
                    </div>
                  </div>
                </v-tooltip>
                <span v-else>/</span>
              </div>
              <div class="item-content" style="width: 120px;">
                <v-select
                  v-model="row.itemType"
                  :items="itemTypeOptions"
                  label="类型"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  item-title="label"
                  item-value="value"
                />
              </div>
              <div class="item-content" style="width: 80px;">
                <v-text-field
                  v-model="row.materialCount"
                  label="数量"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  type="number"
                  @wheel="preventNumberInputWheel"
                  @input="handleQuantityInput(row)"
                />
              </div>
              <div class="item-content" style="width: 100px;">
                <v-select
                  v-model="row.materialUnit"
                  :items="getUnitListByBigClassOrSmallClass(row.bigClass, row.materialType)"
                  label="单位"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  item-title="unitName"
                  item-value="unitName"
                  return-object
                />
              </div>
              <div class="item-content" style="width: 110px;">
                <v-text-field
                  v-model="row.materialPrice"
                  label="单价"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details
                  type="number"
                  @wheel="preventNumberInputWheel"
                  @input="handlePriceInput(row)"
                />
              </div>
              <div class="item-content" style="width: 130px;">
                <v-text-field
                  :model-value="calculateTotalPrice(row.materialPrice, row.materialCount)"
                  label="金额"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  type="number"
                  class="v-field--readonly"
                  readonly
                />
              </div>
              <div class="item-content" style="flex: 1; min-width: 0;">
                <v-textarea
                  v-model="row.remark"
                  label="备注"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details
                  rows="1"
                  auto-grow
                  maxlength="100"
                />
              </div>
              <div class="item-content" style="width: 180px; position: relative;">
                <v-text-field
                  v-model="row.plannedDeliveryDate"
                  label="计划交货"
                  persistent-placeholder
                  variant="outlined"
                  density="compact"
                  hide-details="auto"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  class="native-date-field"
                  @click="openDatePicker(index)"
                />
                <input
                  :ref="el => setDateInputRef(el, index)"
                  type="date"
                  :value="row.plannedDeliveryDate"
                  style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px;"
                  @change="(e) => onDateChange(e, index)"
                >
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="error" variant="tonal" :disabled="submitLoading" @click="handleClose">取消</v-btn>
        <v-btn color="primary" variant="flat" @click="setAllDeliveryTime">批量设置交期</v-btn>
        <v-btn color="primary" variant="flat" :loading="submitLoading" @click="handleConfirm">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="materialFieldDialogVisible"
    max-width="700"
  >
    <v-card class="purchase-dialog">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>编辑采购项信息</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="materialFieldDialogVisible = false"
        />
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col
            v-if="editingMaterialRef && editingMaterialRef.partName && editingMaterialRef.partName != '/'"
            cols="12"
            sm="6"
          >
            <v-text-field
              v-model="materialFieldForm.partName"
              label="零件名称"
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col>
          <v-col v-if="editingMaterialRef" cols="12" sm="6">
            <v-text-field
              v-model="materialFieldForm.materialName"
              label="名称"
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col>
          <v-col v-if="editingMaterialRef" cols="12" sm="6">
            <v-text-field
              v-model="materialFieldForm.specDesc"
              label="规格型号"
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col>
          <v-col v-if="editingMaterialRef" cols="12" sm="6">
            <v-text-field
              v-model="materialFieldForm.materialCode"
              label="编码"
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" variant="tonal" @click="materialFieldDialogVisible = false">取消</v-btn>
        <v-btn color="primary" variant="flat" @click="confirmMaterialFieldDialog">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- 批量设置交期弹窗 -->
  <v-dialog
    v-model="batchDateDialogVisible"
    max-width="360"
    persistent
  >
    <v-card class="purchase-dialog">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>批量设置交期</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="batchDateDialogVisible = false"
        />
      </v-card-title>
      <v-card-text>
        <div class="native-date-wrapper">
          <v-text-field
            v-model="batchDateValue"
            label="选择日期"
            persistent-placeholder
            variant="outlined"
            density="compact"
            hide-details="auto"
            prepend-inner-icon="mdi-calendar"
            readonly
            class="native-date-field"
            @click="openBatchDatePicker"
          />
          <!-- :min="getTodayDate()" -->
          <input
            ref="batchDateInputRef"
            type="date"
            :value="batchDateValue"
            style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
            @change="onBatchDateChange"
          />
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="error" variant="tonal" @click="batchDateDialogVisible = false">
          取消
        </v-btn>
        <v-btn color="primary" variant="flat" @click="confirmBatchDate">
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { contractApi, purchaseApi } from '@/services/api'
import { itemTypeOptions } from '@/constants/contract' 
import editIcon from '@/assets/edit.png'
import inputTipImg from '@/assets/inputTip.png'

const props = withDefaults(
  defineProps<{
    modelValue: boolean
    rows: any[]
    /** 项目名称，与 PurchaseDialog 一致 */
    projectName?: string | null
    /** 合同唯一码/编号，与 PurchaseDialog 一致 */
    contractCode?: string | null
    /** 合同 ID，提交 /jf/purchase/addPurchaseItems 必填 */
    contractId?: number | string | null
    /** 产品订单项 ID（按品项汇总页路由参数，后端需要时传入） */
    productOrderItemId?: number | string | null
    /** 用于 purchaseProductQuantityInfo，与 PurchaseDialog 一致 */
    warehouseNo?: string | null
  }>(),
  {
    projectName: null,
    contractCode: null,
    contractId: null,
    productOrderItemId: null,
    warehouseNo: null,
  }
)
const emit = defineEmits<{
  (e: 'update:modelValue', val: boolean): void
  /** 提交 addPurchaseItems 成功 */
  (e: 'success', rows: any[]): void
}>()

const { showError, showSuccess } = useSnackbar()
const submitLoading = ref(false)
const localRows = ref<any[]>([])
const dateInputRefs = ref<Record<number, HTMLInputElement | null>>({})
const unitOptions = ref<any[]>([])
const batchDateDialogVisible = ref(false)
const batchDateValue = ref('')
const batchDateInputRef = ref<HTMLInputElement | null>(null)

const loadUnitList = async () => {
  try {
    const res = await contractApi.getUnitList()
    if (res?.code === 0 && res.data) {
      unitOptions.value = res.data
    }
  } catch (error) {
    console.error('加载单位列表失败:', error)
  }
}

/** 与 PurchaseDialog.vue 一致：根据大类/小类取可选单位（当前返回全部 unitName） */
const getUnitListByBigClassOrSmallClass = (_bigClass: string, _smallClass: string) => {
  return unitOptions.value.map((item: any) => item.unitName)
}

onMounted(() => {
  loadUnitList()
})

const materialFieldDialogVisible = ref(false)
const materialFieldForm = reactive({
  partName: '',
  materialName: '',
  specDesc: '',
  materialCode: '',
})
let editingMaterialRef: any = null

/** 接口可能返回 string[] 或逗号分隔字符串（与 PurchaseDialog.vue 一致） */
function normalizeProductCodesField(v: any): string[] {
  if (Array.isArray(v)) return v.map((x) => String(x).trim()).filter(Boolean)
  if (v == null || v === '') return []
  if (typeof v === 'string') {
    return v
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  }
  return []
}

function resolveWarehouseNoForQuantityInfo(rows: any[]): string {
  const fromProp = String(props.warehouseNo ?? '').trim()
  if (fromProp) return fromProp
  const fromRow = rows.find((r: any) => r?.warehouseNo && String(r.warehouseNo).trim())
  return fromRow ? String(fromRow.warehouseNo).trim() : ''
}

/** 打开弹窗后拉取库存、采购中、单价、关联产品等（与 PurchaseDialog openForRequisition 一致） */
async function applyPurchaseProductQuantityInfo() {
  const rows = localRows.value
  const materialCodes = rows.map((r: any) => r.materialCode).filter(Boolean)
  if (materialCodes.length === 0 || materialCodes.length !== rows.length) return
  const warehouseNo = resolveWarehouseNoForQuantityInfo(rows)
  try {
    const res: any = await purchaseApi.purchaseProductQuantityInfo({
      materialCodes: materialCodes.join(','),
      warehouseNo,
    })
    if (res?.code === 0 && res.data) {
      rows.forEach((row: any) => {
        const matched = res.data.find((m: any) => m.materialCode === row.materialCode)
        if (matched) {
          row.bomEstimate = matched.bomEstimate
          row.bomEstimateUnit = matched.bomEstimateUnit
          row.inventory = matched.inventory
          row.inventoryUnit = matched.inventoryUnit
          row.purchasing = matched.purchasing
          row.purchasingUnit = matched.purchasingUnit
          row.materialPrice = matched.price
          if (matched.productCodes != null && matched.productCodes !== '') {
            const normalized = normalizeProductCodesField(matched.productCodes)
            if (normalized.length > 0) row.productCodes = normalized
          }
        }
      })
    }
  } catch (e) {
    console.error('purchaseProductQuantityInfo', e)
  }
}

watch(
  () => props.modelValue,
  async (val) => {
    if (!val) return
    localRows.value = (props.rows || []).map((row: any) => {
      const rawCount = row.materialCount ?? row.productUsageSum ?? row.totalUsage ?? null
      return {
        ...row,
        materialCount: rawCount != null ? formatNumberUse(rawCount, 4) : '',
        materialUnit: row.materialUnit ?? row.materialUsageUnit ?? row.unit ?? '',
        materialPrice: row.materialPrice != null ? formatNumberUse(row.materialPrice, 2) : '',
        remark: row.remark ?? '',
        plannedDeliveryDate: row.plannedDeliveryDate ?? '',
        specDesc: row.specDesc ?? row.materialSpec ?? '',
        itemType: row.itemType ?? row.type ?? 0,
        productCodes: normalizeProductCodesField(row.productCodes),
      }
    })
    await applyPurchaseProductQuantityInfo()
  },
  { immediate: true }
)

function setDateInputRef(el: any, index: number) {
  if (el) dateInputRefs.value[index] = el
}

function openDatePicker(index: number) {
  nextTick(() => {
    const input = dateInputRefs.value[index]
    if (!input) return
    if (typeof (input as any).showPicker === 'function') (input as any).showPicker()
    else input.click()
  })
}

function onDateChange(event: Event, index: number) {
  const target = event.target as HTMLInputElement
  const row = localRows.value[index]
  if (row) row.plannedDeliveryDate = target.value
}

function calculateTotalPrice(price: any, quantity: any) {
  return Number(((Number(price) || 0) * (Number(quantity) || 0)).toFixed(3))
}

const formatNumberUse = (num: number | string | null | undefined, decimals: number = 4): string => {
  if (num === null || num === undefined || num === '') {
    return ''
  }
  const n = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(n)) {
    return ''
  }
  return parseFloat(n.toFixed(decimals)).toString()
}

const preventNumberInputWheel = (event: WheelEvent) => {
  event.preventDefault()
  const target = event.target as HTMLInputElement | null
  target?.blur()
}

const handleQuantityInput = (material: any) => {
  let value = String(material.materialCount || '').trim()
  value = value.replace(/[^\d.]/g, '')

  const dotIndex = value.indexOf('.')
  if (dotIndex !== -1) {
    const beforeDot = value.substring(0, dotIndex)
    const afterDot = value.substring(dotIndex + 1).replace(/\./g, '').substring(0, 4)
    value = beforeDot + '.' + afterDot
  }

  if (value === '' || value === '.') {
    material.materialCount = ''
    return
  }

  if (value.startsWith('.')) {
    value = '0' + value
  }

  value = value.replace(/^0+(\d)/, '$1')
  const num = parseFloat(value)

  if (!isNaN(num) && num >= 0) {
    material.materialCount = value
  } else {
    material.materialCount = ''
  }
}

const handlePriceInput = (material: any) => {
  let value = String(material.materialPrice || '').trim()
  value = value.replace(/[^\d.]/g, '')

  const dotIndex = value.indexOf('.')
  if (dotIndex !== -1) {
    const beforeDot = value.substring(0, dotIndex)
    const afterDot = value.substring(dotIndex + 1).replace(/\./g, '').substring(0, 4)
    value = beforeDot + '.' + afterDot
  }

  if (value === '' || value === '.') {
    material.materialPrice = ''
    return
  }

  if (value.startsWith('.')) {
    value = '0' + value
  }

  const num = parseFloat(value)
  if (!isNaN(num) && num >= 0) {
    material.materialPrice = value
  } else {
    material.materialPrice = ''
  }
}

function openMaterialFieldDialog(material: any) {
  editingMaterialRef = material
  materialFieldForm.partName = material.partName ?? ''
  materialFieldForm.materialName = material.materialName ?? ''
  materialFieldForm.specDesc = material.specDesc ?? material.materialSpec ?? ''
  materialFieldForm.materialCode = material.materialCode ?? ''
  materialFieldDialogVisible.value = true
}

function confirmMaterialFieldDialog() {
  if (!editingMaterialRef) return
  editingMaterialRef.partName = materialFieldForm.partName
  editingMaterialRef.materialName = materialFieldForm.materialName
  editingMaterialRef.specDesc = materialFieldForm.specDesc
  editingMaterialRef.materialSpec = materialFieldForm.specDesc
  editingMaterialRef.materialCode = materialFieldForm.materialCode
  materialFieldDialogVisible.value = false
  editingMaterialRef = null
}

function handleClose() {
  emit('update:modelValue', false)
}

/** 单位：v-select return-object 时取 unitName，与发起采购明细一致 */
function normalizeMaterialUnit(u: any): string {
  if (u == null || u === '') return ''
  if (typeof u === 'object' && u != null && 'unitName' in u) return String((u as any).unitName ?? '')
  return String(u)
}

// 统一设置交期
const setAllDeliveryTime = () => {
  // batchDateValue.value = getTodayDate()
  batchDateDialogVisible.value = true
}

const openBatchDatePicker = () => {
  nextTick(() => {
    const input = batchDateInputRef.value
    if (input) {
      if (typeof (input as any).showPicker === 'function') {
        ;(input as any).showPicker()
      } else {
        input.click()
      }
    }
  })
}

const onBatchDateChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.value) {
    batchDateValue.value = target.value
  }
}

const confirmBatchDate = () => {
  if (!batchDateValue.value) {
    showError('请选择日期')
    return
  }
  localRows.value.forEach((material: any) => {
    if (material) {
      material.plannedDeliveryDate = batchDateValue.value
    }
  })
  batchDateDialogVisible.value = false
}

/**
 * 单条明细结构与 PurchaseDialog.vue submitPurchase 中 materialList 项一致
 */
function buildPurchaseMaterialListItem(row: any) {
  const materialUnit = normalizeMaterialUnit(row.materialUnit)
  const base: any = {
    materialCode: row.materialCode,
    quantity: row.materialCount,
    materialTotalCount: row.materialTotalCount ?? row.productUsageSum ?? row.materialCount,
    price: row.materialPrice,
    remark: row.remark,
    brand: row.brand,
    materialName: row.materialName,
    specDesc: row.specDesc ?? row.materialSpec,
    materialUnit,
    plannedDeliveryDate: row.plannedDeliveryDate,
    bomEstimate: row.bomEstimate,
    bomEstimateUnit: row.bomEstimateUnit,
    inventory: row.inventory,
    inventoryUnit: row.inventoryUnit,
    purchasing: row.purchasing,
    purchasingUnit: row.purchasingUnit,
    materialRemark: row.materialRemark,
    materialType: row.materialType || row.smallClass,
    bigClass: row.bigClass,
    // smallClass: row.smallClass,
    contractCode: row.contractCode,
    batch: row.batch,
    syscode: row.syscode,
    type: row.type ?? 0,
    itemType: row.itemType ?? row.type ?? 0,
    bomKey: row.bomKey,
    partName: row.partName,
    contractNo: row.contractNo,
    productCodes: (Array.isArray(row.productCodes) ? row.productCodes : []).join(',') || '',
    purchaseItemType: row.purchaseItemType ?? 0,
  }
  if (row.requisitionItemId != null && row.requisitionItemId !== '') {
    base.requisitionItemId = row.requisitionItemId
  }
  if (row.itemId != null) {
    base.itemId = row.itemId
  }
  return base
}

async function handleConfirm() {
  const invalid = localRows.value.find((row: any) => !Number(row.materialCount) || row.materialPrice == null || row.materialPrice === '')
  // const invalid = localRows.value.find((row: any) => !Number(row.materialCount) || !Number(row.materialPrice))
  if (invalid) {
    showError('请完善数量和单价')
    return
  }
  const cid = props.contractId
  if (cid === null || cid === undefined || cid === '' || Number(cid) <= 0) {
    showError('缺少合同信息，无法提交')
    return
  }
  const materialList = localRows.value.map((row: any) => buildPurchaseMaterialListItem(row))
  const submitData: Record<string, any> = {
    contractId: Number(cid),
    materialList,
    contractCode: props.contractCode || undefined,
    projectName: props.projectName || undefined,
  }
  const poi = props.productOrderItemId
  if (poi !== null && poi !== undefined && poi !== '' && Number(poi) > 0) {
    submitData.productOrderItemId = Number(poi)
  }
  submitLoading.value = true
  try {
    const res: any = await purchaseApi.addPurchaseItems(submitData)
    if (res?.code === 0) {
      showSuccess(res?.message || res?.msg || '添加采购项成功')
      emit('success', localRows.value)
      emit('update:modelValue', false)
    } else {
      showError(res?.message || res?.msg || '添加采购项失败')
    }
  } catch (error: any) {
    console.error('addPurchaseItems', error)
    showError(error?.message || '添加采购项失败')
  } finally {
    submitLoading.value = false
  }
}
</script>

<style scoped lang="scss">
/* 与 PurchaseDialog.vue 中 .purchase-dialog 一致（含「编辑采购项信息」子弹窗） */
.purchase-dialog {
  background-color: #2b2d33 !important;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
}

.purchase-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
}

.purchase-dialog :deep(.v-card-text) {
  padding: 24px;
  flex: 1 1 auto;
  overflow-y: auto;
}

.purchase-dialog :deep(.v-card-actions) {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.purchase-dialog :deep(.v-autocomplete .v-field__input),
.purchase-dialog :deep(.v-text-field .v-field__input),
.purchase-dialog :deep(.v-autocomplete input),
.purchase-dialog :deep(.v-text-field input),
.purchase-dialog :deep(.v-select .v-field__input),
.purchase-dialog :deep(.v-select input),
.purchase-dialog :deep(.v-select .v-select__selection-text) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__outline),
.purchase-dialog :deep(.v-text-field .v-field__outline),
.purchase-dialog :deep(.v-select .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__input::placeholder),
.purchase-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.purchase-dialog :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__append-inner i),
.purchase-dialog :deep(.v-text-field .v-field__append-inner i),
.purchase-dialog :deep(.v-select .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-list) {
  background-color: #2b2d33 !important;
}

.purchase-dialog :deep(.v-list-item) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.purchase-dialog :deep(.v-list-item-title) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.purchase-dialog :deep(.v-messages__message) {
  color: #ff5252 !important;
}

.purchase-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.purchase-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
}

.purchase-dialog :deep(input[type="number"]) {
  appearance: textfield;
  -moz-appearance: textfield;
}

.purchase-dialog :deep(.mdi) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-field--readonly) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.purchase-dialog :deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.purchase-dialog :deep(.v-field--readonly .mdi-menu-down) {
  display: none !important;
}

.purchase-dialog::-webkit-scrollbar,
.purchase-dialog :deep(.v-card-text)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.purchase-dialog::-webkit-scrollbar-track,
.purchase-dialog :deep(.v-card-text)::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.purchase-dialog::-webkit-scrollbar-thumb,
.purchase-dialog :deep(.v-card-text)::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.purchase-dialog::-webkit-scrollbar-thumb:hover,
.purchase-dialog :deep(.v-card-text)::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.2) 100%);
  border-color: rgba(255, 255, 255, 0.2);
}

.material-purchase-list {
  margin: 10px 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.material-purchase-header {
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  background-color: rgba(255, 255, 255, 0.04);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.material-purchase-item {
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.item-content {
  color: #fff;
  padding: 0 4px;
  word-break: break-all;
  text-align: center;
}

.material-name {
  color: #fff;
}

.material-code {
  color: #898989;
  font-size: 12px;
}

.purchase-item-editable {
  position: relative;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.12);
  min-height: 48px;
  padding: 4px 4px 6px;
  text-align: left;
}

.purchase-item-edit-icon {
  position: absolute;
  right: -6px;
  top: -6px;
  width: 16px;
  height: 16px;
}

/* 常规物料：关联产品只读展示（与 PurchaseDialog.vue isFactoryMaterialPurchase 一致） */
.purchase-associated-products-tip-img {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  cursor: pointer;
  display: inline-block;
}

.purchase-associated-products-tip-wrap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.purchase-associated-products-count {
  font-size: 12px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.85);
}

.purchase-associated-products-tooltip {
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-all;
}

/* 原生日期输入框包装器样式 */
.native-date-wrapper {
  position: relative;
}

.native-date-wrapper :deep(.v-field__input){
  cursor: pointer;
}

.native-date-field {
  cursor: pointer;
}

.native-date-field:hover {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.native-date-field:focus-within {
  border-color: #D2475D !important;
}

</style>
